import { router } from "@inertiajs/react";
import Header from "../Component/Header";

export default function Index({ data = [] }) {
    const resolveMemberPhoto = (photo) => {
        if (!photo) return null;
        if (/^https?:\/\//i.test(photo)) return photo;
        return `/storage/${photo}`;
    };

    const statusBadgeClass = (status) => {
        switch (Number(status)) {
            case 1:
                return "bg-green-100 text-green-700";
            case 2:
                return "bg-red-100 text-red-700";
            default:
                return "bg-amber-100 text-amber-700";
        }
    };

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <div>
                            <h1 className="text-lg md:text-xl font-semibold text-foreground">Member</h1>
                            <p className="text-sm text-muted-foreground-1">List of registered members.</p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-6 space-y-4">
                                <div className="flex flex-col bg-card border border-card-line overflow-hidden rounded-xl shadow-2xs">
                                    <div className="py-3 px-5 flex justify-between items-center gap-x-5 border-b border-card-header">
                                        <h2 className="inline-block font-semibold text-foreground">
                                            Member List
                                        </h2>
                                        <button
                                            type="button"
                                            onClick={() => router.visit("/panel/create-member")}
                                            className="py-2 px-2.5 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground shadow-2xs hover:bg-layer-hover"
                                        >
                                            Add Member
                                        </button>
                                    </div>

                                    <div className="p-5 space-y-4">
                                        <div className="overflow-x-auto [&amp;::-webkit-scrollbar]:h-2 [&amp;::-webkit-scrollbar-thumb]:rounded-none [&amp;::-webkit-scrollbar-track]:bg-scrollbar-track [&amp;::-webkit-scrollbar-thumb]:bg-scrollbar-thumb">
                                            <div className="min-w-full inline-block align-middle">
                                                <table className="min-w-full divide-y divide-table-line">
                                                    <thead>
                                                        <tr>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Photo</th>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Member</th>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Code</th>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Status</th>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Phone</th>
                                                            <th className="py-2.5 px-4 text-start text-sm font-normal text-muted-foreground-1">Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="divide-y divide-table-line">
                                                        {data.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={6} className="py-6 px-4 text-sm text-muted-foreground-2 text-center">
                                                                    No members found.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            data.map((member) => {
                                                                const userName = member.user?.name ?? "-";
                                                                const userEmail = member.user?.email ?? "-";
                                                                const photoUrl = resolveMemberPhoto(member.mem_photo);

                                                                return (
                                                                    <tr key={member.mem_id} className="hover:bg-surface">
                                                                        <td className="py-3 px-4">
                                                                            {photoUrl ? (
                                                                                <img
                                                                                    src={photoUrl}
                                                                                    alt={userName}
                                                                                    className="h-12 w-12 rounded-lg border border-layer-line object-cover"
                                                                                />
                                                                            ) : (
                                                                                <div className="flex h-12 w-12 items-center justify-center rounded-lg border border-dashed border-layer-line text-xs text-muted-foreground-1">
                                                                                    N/A
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                        <td className="py-3 px-4">
                                                                            <div className="flex flex-col">
                                                                                <span className="text-sm font-medium text-foreground">
                                                                                    {userName}
                                                                                </span>
                                                                                <span className="text-xs text-muted-foreground-1">{userEmail}</span>
                                                                            </div>
                                                                        </td>
                                                                        <td className="py-3 px-4 text-sm text-foreground">{member.mem_code}</td>
                                                                        <td className="py-3 px-4">
                                                                            <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${statusBadgeClass(member.mem_status)}`}>
                                                                                {member.mem_status_label ?? "Pending"}
                                                                            </span>
                                                                        </td>
                                                                        <td className="py-3 px-4 text-sm text-muted-foreground-2">{member.mem_phone || "-"}</td>
                                                                        <td className="py-3 px-4">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => router.visit(`/panel/members/${member.mem_id}`)}
                                                                                className="inline-flex items-center rounded-lg border border-layer-line bg-layer px-3 py-2 text-sm font-medium text-layer-foreground hover:bg-layer-hover"
                                                                            >
                                                                                View
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
